import React from 'react'
import { ElementProps } from '../base/element'
import { Item } from '../base/item'
import { useDragDrop } from '../helpers/useDragDrop'
import { IValueType, SchemaManager } from '../schemamanager/schemaManager'

import {
  IComponent,
  IPropStyle,
  IPropStyles
} from '../schemamanager/types'
import { IDataTableActions, IDataTableComponent } from './datatable'
import { DetailComponentButtonsFunc, RowToolbarFunc} from '../helpers/datatableItems'

export interface ElementCardsProps extends ElementProps {
  m: IPropStyles
}

export const DataTableCards = (props: ElementCardsProps) => {
  const { sm, m } = props
  const comp = props.comp as IDataTableComponent
  const options = comp.options || {}
  const fields = sm.getFieldsOfDataTable(comp)
  const isModal = comp.detailComponent.type === 'modal'

  const { val: data, memval: memdata } = sm.getValuesDataTable(comp)
  const keyFieldComp = sm.getCompByField(sm.getDataTableKeyField(comp))
  const showRowToolbar = (o: IDataTableActions): boolean =>
    !!o.add || !!o.copy || !!o.edit || !!o.delete

  const dtc = sm.getCompByName('detailcomponentbuttons')
  if (!dtc) {
    comp.detailComponent['children'].push(DetailComponentButtonsFunc(sm, comp) as IComponent)
  } else {
    const ind = (comp.detailComponent['children'] as Array<IComponent>).findIndex(c => c === dtc)
    if (ind > -1) {
      comp.detailComponent['children'][ind] = DetailComponentButtonsFunc(sm, comp) as IComponent
    }
  }
  

  const dnd = useDragDrop()
  if (comp.options?.dragdrop) {
    dnd.InitData(data, memdata)
  }

  const dndProps = (ind: number) =>
    comp.options?.dragdrop
      ? {
          draggable: true,
          onDragStart: dnd.onDragStart(ind),
          onDragOver: dnd.onDragOver,
          onDragEnter: dnd.onDragEnter(ind),
          onDrop: dnd.onDrop,
          onDragEnd: dnd.onDragEnd(dropped)
        }
      : {}

  const dropped = (dropdata: any, dropmemdata: any) => {
    if (dropdata) {
      sm.updateValue(comp, dropdata)
      sm.MemValues[comp.field!] = dropmemdata
      sm.RenderComponent(comp)
    }
  }

  const rowClick = (ind: number) => () => {
    if (options.rowSelecting) comp.selectedRowIndex = ind
    if (options!.editOnSingleClick) {
      if (ind === comp.editRowIndex) {
        sm.SaveChangesDataTable(comp)
      } else {
        if (typeof comp.editRowIndex === 'undefined' || comp.editRowIndex === -1) {
          sm.EditDataTableRow(comp, ind)
        }
      }
    }
  }

  const rowDoubleClick = (ind: number) => () => {
    if (options.rowSelecting) comp.selectedRowIndex = ind
    if (options!.editOnDoubleClick) {
      if (ind === comp.editRowIndex) {
        sm.SaveChangesDataTable(comp)
      } else {
        if (typeof comp.editRowIndex === 'undefined' || comp.editRowIndex === -1) {
          sm.EditDataTableRow(comp, ind)
        }
      }
    }
  }

  const getStyleCard = (ind: number): IPropStyle => {
    const ret: IPropStyle = {
        className: m.styleCard.className,
        style: m.styleCard.style
    }
    if (options.tableStriped) {
      if (ind % 2 === 0) {
        ret.className = ret.className + ' ' + m.styleCardEven
      } else {
        ret.className = ret.className + ' ' + m.styleCardOdd
      }
    } 
    let diff = false
    fields.forEach(f => {
      if (sm.getDiffHighlight(f, ind)) {
        diff = true
      }
    })
    if (diff) {
      ret.className = ret.className + ' ' + sm.DiffClassName
    }
    return ret
  }

  const getCards = () => {
    return (
      data &&
      keyFieldComp &&
      data.map((row: any, ind: number) => {
        const key = sm.getValue(keyFieldComp, ind)
        return (
          <React.Fragment key={key}>
            <div
              {...dndProps(ind)}
              tabIndex={0}
              onClick={rowClick(ind)}
              onDoubleClick={rowDoubleClick(ind)}
              {...getStyleCard(ind)}
            >
              {getSummaryCard(row, ind)}  
              {getCardToolbar(ind)}
            </div>
            {!isModal && comp.editRowIndex === ind && (
              <div>
                <Item sm={sm} comp={comp.detailComponent as IComponent} />
              </div>
            )}
          </React.Fragment>
        )
      })
    )
  }

  const getCardToolbar = (ind: number) => {
    if (!showRowToolbar(options!.rowActions!)) return null
    const rowtoolbar = RowToolbarFunc(sm, comp, ind)
    return (
      <Item sm={sm} comp={rowtoolbar}></Item>
    )
  }

  const getSummaryCard = (row: any, arrayInd: number) => {
    if (comp.summaryCard) {
      const res = comp.summaryCard({
        sm,
        comp,
        value: row,
        arrayInd
      })
      const typ = SchemaManager.checkValueType(res)
      if (typ === IValueType.component) {
        return <Item {...props} comp={res}></Item>
      } else {
        if (typ !== IValueType.undefined) {
          return <span>{res}</span>
        } else {
          return <div>summaryCard function returned no value!</div>
        }
      }
    } else {
      return <div>No summaryCard function defined!</div>
    }
  }


  return (
    <div {...m.styleCardContent}>
      {getCards()}
    </div>
  )
}
